import React from 'react';
import { AlertCircleIcon } from '@newcore/icons';
import { Onboarding } from '@/features/onboarding/components/primitives';

interface CompleteStepErrorProps {
  error: string;
  onRetry: () => void;
}

/**
 * Error state UI for CompleteStep
 * Shows error message with retry button
 */
export const CompleteStepError: React.FC<CompleteStepErrorProps> = ({
  error,
  onRetry,
}) => {
  return (
    <div className='flex flex-col items-center text-center space-y-6 py-4'>
      <Onboarding.Icon className='h-20 w-20 bg-error-solid/10 text-error-primary [&>svg]:h-10 [&>svg]:w-10'>
        <AlertCircleIcon />
      </Onboarding.Icon>

      <div className='space-y-2'>
        <Onboarding.Title className='text-error-primary'>
          Setup Failed
        </Onboarding.Title>
        <Onboarding.Description className='max-w-sm'>
          {error}
        </Onboarding.Description>
      </div>

      <Onboarding.Error
        error='Unable to complete authentication. This may be due to a network issue or session timeout.'
        className='w-full max-w-sm'
      />

      <Onboarding.NextButton onClick={onRetry} className='w-full max-w-sm'>
        Try Again
      </Onboarding.NextButton>
    </div>
  );
};
